import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import renderIf from 'render-if';
import {generalConfig, routes} from "../../util/config";
import {removeTokenUserStorage, setAlertOnRedux, validRemoveTokenUserStorage} from "../../actions";
import {alertLabels, files, labels, messages} from "../../util/constants";
import TableGridExperience from "../../components/TableGridExperiences/TableGridExperiences";
import './experiencesHistory.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCommentAlt, faDownload} from "@fortawesome/free-solid-svg-icons";
import FilterExperience from "../../components/filterExperience/FilterExperience";
import {CSVLink} from "react-csv";
import {getDownloadData, getDownloadHeader} from "./experiencesFileDownload";
import moment from "moment/moment";
import httpHttpsRequest from '../../util/http-request/request';
import { getComponentGroupOptions, getAllExperiencesOptions } from '../../util/optionsRequest';

class ExperiencesHistory extends Component {

    constructor(props){
        super(props);
        this.state ={
            experiencesData: [],
            componentGroupData: []
        };
        this.options = {
            sortName: ['user_name'],
            sortOrder: ['asc'],
        };
    };

    componentWillMount(){
        this.getDataGroups();
        this.getDataExperiences({});
    };

    getDataExperiences = (params) => {
        let http = new httpHttpsRequest(getAllExperiencesOptions);
        http.addQueryString(params);

        http.makeRequest().then((data)=>{this.experiencesSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    experiencesSuccess = (response) => {
        if(response.data && response.data.length > 0) {
            this.setState({experiencesData: []}, () => {
                this.setState({experiencesData: response.data});
            });
        } else {
            this.setState({experiencesData: []}, () => {
                this.setState({experiencesData: []});
            });
            setAlertOnRedux(true,alertLabels.iconInfo,messages.emptyData, alertLabels.alertInfo);
        }
    };

    callBackError = (response) => {
        try {
            if (validRemoveTokenUserStorage(response.statusCode)) {
                removeTokenUserStorage();
            }
            setAlertOnRedux(true, alertLabels.iconError, JSON.parse(response.body).message, alertLabels.alertDanger);
        }catch(err){
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger);
        }
    };

    getDataGroups = () => {
        let http = new httpHttpsRequest(getComponentGroupOptions);
        http.makeRequest().then((response) => {
            let data = JSON.parse(response);
            if (data.success) {
                this.setState({componentGroupData: []}, () => {
                    this.setState({componentGroupData: data.data});
                });
            }
        }).catch(() => {
            this.setState({componentGroupData: []}, () => {
                this.setState({componentGroupData: []});
            });
        });
    };

    redirectToExperience = (data) =>{
        let experienceData = {...data};
        this.props.history.push({
            pathname: routes.experience,
            params: { id_experience: experienceData.id_experience, profile_type: experienceData.profile_type }
        })
    };

    getFileName = () => {
        return `${files.experienceFile}${moment(new Date()).format(generalConfig.dateFileConcat)}${files.CSVFile}`;
    };

    render() {
        return (
            <div className="experiences">
                <h1 className='title'>{'\u00A0'} <FontAwesomeIcon icon={faCommentAlt} />{'\u00A0'} {labels.experiencesUser}</h1>
                <FilterExperience search={this.getDataExperiences}/>
                {
                    renderIf(this.state.experiencesData.length > 0)
                    (
                        <CSVLink
                            data={getDownloadData(this.state.experiencesData, this.state.componentGroupData)}
                            headers={getDownloadHeader()}
                            filename={this.getFileName()}
                            separator={files.CSVSeparator}>
                            <h5 className='downloadExpBtn'>{'\u00A0'} <FontAwesomeIcon icon={faDownload}/>{'\u00A0'} {labels.download}</h5>
                        </CSVLink>
                    )
                }
                {
                    renderIf(this.state.experiencesData.length > 0)
                    (
                        <TableGridExperience data={this.state.experiencesData} redirectToExperience={this.redirectToExperience}/>
                    )
                }
            </div>
        )
    }
}

export default withRouter(ExperiencesHistory);



// WEBPACK FOOTER //
// ./src/containers/experiences/experiencesHistory.js